import { theme, Typography } from '@/design-system';

import { SummaryCard, SummaryGrid, SummaryValue } from './portfolio-summary.styled';

interface PortfolioSummaryProps {
  summary: Array<{ label: string; value: string | number }>;
}

export const PortfolioSummary = ({ summary }: PortfolioSummaryProps) => (
  <SummaryGrid aria-label="Portfolio summary">
    {summary.map((item) => (
      <SummaryCard key={item.label}>
        <SummaryValue variant="h6" noWrap title={String(item.value)}>
          {item.value}
        </SummaryValue>
        <Typography variant="body3" color={theme.colors.text.secondary}>
          {item.label}
        </Typography>
      </SummaryCard>
    ))}
  </SummaryGrid>
);
